import React, { useEffect } from 'react';
import { Form, Input, DatePicker, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

const { TextArea } = Input;

const HolidayForm = ({ onSubmit, holiday, loading }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (holiday) {
      form.setFieldsValue({
        name: holiday.name,
        date: holiday.date ? dayjs(holiday.date) : null,
        description: holiday.description,
      });
    } else {
      form.resetFields();
    }
  }, [holiday, form]);

  const handleFinish = (values) => {
    const formData = {
      name: values.name,
      date: values.date.format('YYYY-MM-DD'),
      description: values.description || null,
    };
    onSubmit(formData);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      autoComplete="off"
    >
      <Form.Item
        name="name"
        label={t('employee.holiday.form.nameLabel')}
        rules={[
          { required: true, message: t('employee.holiday.form.nameRequired') },
          { max: 100, message: t('employee.holiday.form.nameMaxLength') },
        ]}
      >
        <Input placeholder={t('employee.holiday.form.namePlaceholder')} />
      </Form.Item>

      <Form.Item
        name="date"
        label={t('employee.holiday.form.dateLabel')}
        rules={[{ required: true, message: t('employee.holiday.form.dateRequired') }]}
      >
        <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
      </Form.Item>

      <Form.Item
        name="description"
        label={t('employee.holiday.form.descriptionLabel')}
        rules={[{ max: 500, message: t('employee.holiday.form.descriptionMaxLength') }]}
      >
        <TextArea
          rows={3}
          placeholder={t('employee.holiday.form.descriptionPlaceholder')}
          showCount
          maxLength={500}
        />
      </Form.Item>

      <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
        <Space>
          <Button type="primary" htmlType="submit" loading={loading}>
            {holiday ? t('common.update') : t('common.create')}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default HolidayForm;
